import { formatDate } from '@/helper'

export default {
  getData (state, _getters, _rootState, rootGetters) {
    const data = state.data

    const getDefaultValues = rootGetters['settings/getDefaultValues']
    const getProductListName = (productList) => productList.reduce((acc, product) => {
      acc.push(rootGetters['product/getDataObject']?.[product]?.title)

      return acc
    }, [])

    return data.map(item => {
      return {
        ...item,
        userName: item?.user ? `${item.user.name} ${item.user.surname}` : 'Сотрудник удален',
        createdAtFormatted: formatDate(item.createdAt),
        productListName: getProductListName(item?.sale?.productList || []),
        operationTypeName: getDefaultValues?.['cash-operation']?.filter(({ code }) => code === item.operationType)[0]?.name
      }
    })
  }
}